import React, { useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import { ERROR, SUCCESS, WARNING } from '../../constants';
import ToastContext from './ToastContext';

const ToastProvider = ({ children }) => {
  const [shouldRender, setShouldRender] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);

  const showError = (errorMessage) => {
    setShouldRender(true);
    setType(ERROR);
    setMessage(errorMessage);
  };

  const showSuccess = (successMessage) => {
    setShouldRender(true);
    setType(SUCCESS);
    setMessage(successMessage);
  };

  const showWarning = (warningMessage) => {
    setShouldRender(true);
    setType(WARNING);
    setMessage(warningMessage);
  };

  const contextValue = useMemo(
    () => ({
      shouldRender,
      type,
      message,
      setShouldRender,
      showError,
      showSuccess,
      showWarning,
    }),
    [shouldRender, type, message]
  );

  return <ToastContext.Provider value={contextValue}>{children}</ToastContext.Provider>;
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ToastProvider;
